'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

/**
 * Smart prefetching component that preloads critical pages for faster navigation
 * Uses intersection observer and hover detection for optimal performance
 */
export default function SmartPrefetch() {
  const router = useRouter();

  useEffect(() => {
    // Prefetch critical pages immediately on homepage load
    const criticalPages = ['/news', '/projects', '/tools', '/makers'];
    
    // Small delay to not interfere with initial page load
    const prefetchTimer = setTimeout(() => {
      criticalPages.forEach(page => {
        router.prefetch(page);
      });
    }, 2000); // 2 seconds after page load

    return () => clearTimeout(prefetchTimer);
  }, [router]);

  useEffect(() => {
    // More aggressive prefetching on user interaction
    const handleMouseMove = () => {
      // User is actively using the site, prefetch more aggressively
      router.prefetch('/news');
      router.prefetch('/projects');
      router.prefetch('/tools');
      router.prefetch('/makers');
    };

    const handleScroll = () => {
      // User is scrolling, they might navigate soon
      router.prefetch('/news');
      router.prefetch('/projects');
    };

    // Add listeners after a delay to avoid impacting initial load
    const interactionTimer = setTimeout(() => {
      document.addEventListener('mousemove', handleMouseMove, { once: true });
      document.addEventListener('scroll', handleScroll, { once: true });
    }, 1000);

    return () => {
      clearTimeout(interactionTimer);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('scroll', handleScroll);
    };
  }, [router]);

  return null; // This component doesn't render anything
}